import { replace } from 'connected-react-router';

import { ACTION_INITIATED_LOCAL_REP } from '../Widget/actions';

export const GO_NEXT_ACTION = 'GO_NEXT_ACTION';
export const IS_LOCAL_REP_LOADING = 'IS_LOCAL_REP_LOADING';
export const IS_NEXT_ACTION_TRANSITION = 'IS_NEXT_ACTION_TRANSITION';
export const LOCAL_REP_GO_TO_ACTION = 'LOCAL_REP_GO_TO_ACTION';
export const LOCAL_REP_GO_TO_FIND_SCREEN = 'LOCAL_REP_GO_TO_FIND_SCREEN';
export const ON_FIND_YOUR_REP_ERROR = 'ON_FIND_YOUR_REP_ERROR';
export const ON_FIND_YOUR_REP_POPUP = 'ON_FIND_YOUR_REP_POPUP';
export const SET_LOCAL_REPRESENTATIVE = 'SET_LOCAL_REPRESENTATIVE';
export const SET_MULTI_ACTION_CARD_SELECTED = 'SET_MULTI_ACTION_CARD_SELECTED';

export const goToFindLocalRep = actionIdentifier => dispatch => {
    dispatch({
        type: GO_NEXT_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch({
        type: LOCAL_REP_GO_TO_FIND_SCREEN,
        payload: actionIdentifier
    });

    setTimeout(function() {
        dispatch({
            type: ACTION_INITIATED_LOCAL_REP,
            payload: actionIdentifier
        });
    }, 1000);

    dispatch(replace('/multiActionsCard/findRep'));
};

export const selectCard = (item, identifier) => dispatch => {
    var buttonClicked = document.querySelectorAll(
        '[data-action="' + identifier + '"]'
    )[0];
    buttonClicked.classList.add('clicked');

    dispatch({
        type: SET_MULTI_ACTION_CARD_SELECTED,
        payload: item
    });
};
